import { clsx } from 'clsx';
import DallasSkeleton from '../../Skeleton/DallasSkeleton';
import { Props as DallasButtonProps } from './DallasButton';
import styles from './DallasButtonSkeleton.module.scss';

export interface Props
  extends Pick<DallasButtonProps, 'className' | 'rounded' | 'flex'> {
  /**
   * Size of the button
   */
  size?: 'large' | 'regular' | 'small' | 'tiny';
  /**
   * Shape of the button
   */
  shape?: 'square' | 'rectangle';
}

export default function DallasButtonSkeleton({
  className,
  size = 'regular',
  shape = 'rectangle',
  rounded = false,
  flex = false,
}: Props) {
  return (
    <DallasSkeleton
      className={clsx(
        className,
        flex && styles.flex,
        styles[`size_${size}`],
        styles[`shape_${shape}`],
        rounded ? styles.borderRadius_rounded : styles.borderRadius_semiRounded,
      )}
    />
  );
}
